import React from "react";
import "./HeroSection.css";
import HeroImage from "../assets/Rectangle 28.png.webp";
import LightningIcon from "../assets/Vector1.png.webp";
import { useNavigate } from "react-router-dom";

const HeroSection: React.FC = () => {
  const navigate = useNavigate();

  const goToProducts = () => {
    navigate("/products");
  };
  return (
    <div className="hero-section">
      {/* Left Content */}
      <div className="hero-left">
        <div className="hero-text">
          <h1 className="hero-title">
            Lighting Up Your Space, Brightening Your Life
          </h1>
          <p className="hero-description">
            Efficient LED lighting for a brighter, sustainable life.
          </p>
          <button className="hero-button" onClick={goToProducts}>
            Discover Products <span className="home-arrow-right">➔</span>
          </button>
        </div>
        <div className="hero-tips">
          <div className="tip-container">
            <div className="tip-icon">
              <img
                className="tip-lightning"
                src={LightningIcon}
                alt="Lightning Icon"
              />
            </div>
            <p className="tip-text">
              Save energy and costs with long-lasting LED bulbs
            </p>
          </div>
        </div>
      </div>

      {/* Right Image */}
      <div className="hero-right">
        <img src={HeroImage} alt="Family Bonding" className="hero-image" />
      </div>
    </div>
  );
};

export default HeroSection;
